
import {UserActions} from './../../common/auth/UserState'
import {SET_CONFIG} from '../../common/auth/ConfigState'
import {SET_FILTER} from './ActivityStream/constants'
import selected from '../../services/locations/SelectedLocationsStore'
import SessionStore from '../../services/session/SessionStore'
import * as mobxUtils from '../../util/mobxUtils'


export default function linkEvents(
  reduxStore,
) {

  /** user */
  mobxUtils
  .toStream(() => SessionStore.user, {fireImmediately: true})
  .subscribe(user => {
    reduxStore.dispatch({type: UserActions.SET_USER, user})
  })
  /** config (brand config) */
  mobxUtils
  .toStream(() => SessionStore.brandConfig, {
    fireImmediately: true
  })
  .subscribe(config => {
    reduxStore.dispatch({type: SET_CONFIG, config})
  })

  /** group/location dropdown */
  const dispatchGroup = group => {
    const orNull = (group && group.type === 'GROUP' && group.id.slice(0,4) === 'all-') ? null : group;
    let filters = {
      groupId: orNull && orNull.id,
      accountId: group && group.locationsAllBelongToAccountId,
    };

    reduxStore.dispatch({ type: SET_FILTER, filters:
      filters
    })
  };
  selected.selectedEntityObservable().subscribe(value => {
    dispatchGroup(value)
  })


}
